import { render, staticRenderFns } from "./searchList.vue?vue&type=template&id=058488af"
import script from "./searchList.vue?vue&type=script&lang=js"
export * from "./searchList.vue?vue&type=script&lang=js"
import style0 from "./searchList.vue?vue&type=style&index=0&id=058488af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports